import React, { useEffect, useState } from 'react';
import { FaCheck, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FiLock } from 'react-icons/fi';
import { useModal } from 'src/hooks/Modal';
import Input from '../components/Forms/Input';
import MaskedInput from '../components/Forms/MaskedInput';

import SelectSimple from '../components/Forms/SelectSimple';
import { useLanguage } from "../hooks/Language"
import { countries } from "../pages/Products/modules/Login/countries";
import api from '../services/api';
import CheckboxInput from './DashboardPages/core/components/Forms/CheckboxInput';
import states from './SignUp/FormContainer/states';

interface IProps {
    changeCountry: Function;
    countryISO: string;
    checkUserValue?: Function;
    cart?: Record<string, any>[];
    key?: string;
    keyName?: string;
}

export const checkDocumentNumber = async (document_number) => {

    const doc = document_number?.toString().replace(/[^0-9]/g, '');
    const valid = await api.get('check-user-document_number', { params: { document_number: doc } });

    return valid?.data?.valid || 'no';

}


const DefaultSignUpFormV4: React.FC<IProps> = ({ key = 'product', keyName = 'product', checkUserValue = (value) => { }, changeCountry, cart }) => {

    const [countryISO, setCountryISO] = useState('BR')
    const [checkUser, setCheckUser] = useState('')
    const [currentDocumentNumber, setCurrentDocumentNumber] = useState('');
    const { translate } = useLanguage();
    const [category, setCategory] = useState('');
    const { addModal } = useModal();

    useEffect(() => {
        setCheckUser('');
        checkUserValue('');
    }, [keyName])
    const verifyAssociate = async (doc, product) => {



        try {

            const validate = await api.get(`/verify-association-api/${product?.hash_link?.toString()}/${product?.project_id}/${doc}`);

            if (validate.status === 200) {
                return true;
            }
            else {
                return false;
            }


        }
        catch (err) {

            addModal({ theme: 'whiteModalMini', title: '', content: <> <p style={{ color: '#333', padding: '10px', fontSize: '14px', textAlign: 'center', width: '100%' }}>{err?.response?.data?.message || err?.response?.data?.error || 'Produto exclusivo para associados'} </p></> })
            return false;
        }



    }


    return <>
        <SelectSimple index={1} mandatory={true} setCallback={(value) => setCountryISO(value)} options={countries} name="country" label={translate('Pais')} />


        {countryISO === 'BR' ? <MaskedInput mandatory={true}
            mask="999.999.999-99"
            name="document_number"
            setCallback={(value) => setCurrentDocumentNumber(value)}
            placeholder={translate('CPF')}
        /> : <Input setCallback={(value) => setCurrentDocumentNumber(value)} mandatory={true} name="document_number"
            placeholder={translate('Nº do documento')} />}

        {!checkUser ? <button type='button' style={{ margin: '5px auto' }} onClick={async () => {


            const product = cart?.[0];

            if (product?.allowed_only === 'Sim') {
                const checkAssociation = await verifyAssociate(currentDocumentNumber, product);
                if (!checkAssociation) {
                    return;
                }
                else {
                    const check = await checkDocumentNumber(currentDocumentNumber);
                    setCheckUser(check);
                    checkUserValue(check);
                }
            }
            else {

                const check = await checkDocumentNumber(currentDocumentNumber);
                setCheckUser(check);
                checkUserValue(check);

            }



        }} className='greenButton2 buttonColored'>Validar</button> : <></>}
        {checkUser === 'no' ? <>
          
            <Input mandatory={true} name="name" placeholder={translate('Nome completo')} />
            <Input mandatory={true} name="email" placeholder={translate('E-mail')} />
   <SelectSimple   label='Instituição' mandatory={true} index={6} name="company" options={[
{label: "HCPA - Hospital de Clínicas de Porto Alegre", value: "HCPA - Hospital de Clínicas de Porto Alegre"},
{label: "ETS - Escola Técnica em Saúde", value: "ETS - Escola Técnica em Saúde"},
{label: "Fadergs - Faculdade de Desenvolvimento do Rio Grande de Sul", value: "Fadergs - Faculdade de Desenvolvimento do Rio Grande de Sul"},
{label: "Feevale - Universidade Feevale", value: "Feevale - Universidade Feevale"},
{label: "GHC - Grupo Hospitalar Conceição", value: "GHC - Grupo Hospitalar Conceição"},
{label: "HDP - Hospital Divina Providência", value: "HDP - Hospital Divina Providência"},
{label: "HMD - Hospital Mãe de Deus", value: "HMD - Hospital Mãe de Deus"},
{label: "HMV - Hospital Moinhos de Vento", value: "HMV - Hospital Moinhos de Vento"},
{label: "HMIPV - Hospital Materno Infantil Presidente Vargas", value: "HMIPV - Hospital Materno Infantil Presidente Vargas"},
{label: "HPS - Hospital de Pronto Socorro", value: "HPS - Hospital de Pronto Socorro"},
{label: "IC  (FUC) - Instituto de Cardiologia", value: "IC FUC - Instituto de Cardiologia"},
{label: "IFRS - Instituto Federal do Rio Grande do Sul", value: "IFRS - Instituto Federal do Rio Grande do Sul"},
{label: "IPA - Centro Universitário Metodista", value: "IPA - Centro Universitário Metodista"},
{label: "ISCMPA - Santa Casa de Misericórdia de Porto Alegre", value: "ISCMPA - Santa Casa de Misericórdia de Porto Alegre"},
{label: "PUCRS - Pontifícia Universidade Católica do Rio Grande do Sul", value: "PUCRS - Pontifícia Universidade Católica do Rio Grande do Sul"},
{label: "Senac Saúde", value: "Senac Saúde"},
{label: "UCS - Universidade de Caxias do Sul", value: "UCS - Universidade de Caxias do Sul"},
{label: "Uergs - Universidade Estadual do Rio Grande do Sul", value: "Uergs - Universidade Estadual do Rio Grande do Sul"},
{label: "UFCSPA - Universidade Federal de Ciências da Saúde de Porto Alegre", value: "UFCSPA - Universidade Federal de Ciências da Saúde de Porto Alegre"},
{label: "UFJF - Hospital Universitário de Juiz de Fora", value: "UFJF - Hospital Universitário de Juiz de Fora"},
{label: "UFPel - Universidade Federal de Pelotas", value: "UFPel - Universidade Federal de Pelotas"},
{label: "UFRGS - Universidade Federal do Rio Grande do Sul", value: "UFRGS - Universidade Federal do Rio Grande do Sul"},
{label: "UFSM - Universidade Federal de Santa Maria", value: "UFSM - Universidade Federal de Santa Maria"},
{label: "Ulbra - Universidade Luterana do Brasil", value: "Ulbra - Universidade Luterana do Brasil"},
{label: "UNICNEC - Centro Universitário Cenecista de Osório", value: "UNICNEC - Centro Universitário Cenecista de Osório"},
{label: "Unifesp - Universidade Federal de São Paulo", value: "Unifesp - Universidade Federal de São Paulo"},
{label: "Unilasalle - Universidade La Salle", value: "Unilasalle - Universidade La Salle"},
{label: "Unipampa - Universidade Federal do Pampa", value: "Unipampa - Universidade Federal do Pampa"},
{label: "Uniritter - Laureate International Universities", value: "Uniritter - Laureate International Universities"},
{label: "Unisinos - Universidade do Vale do Rio dos Sinos", value: "Unisinos - Universidade do Vale do Rio dos Sinos"},
{label: "Outros", value: "Outros"}
   ]}
   />



            <SelectSimple setCallback={(value) => setCategory(value)} label='Vínculo com o HCPA' mandatory={true} index={7} name="category_id" options={[
        
{label: "Professor(a)", value: "Professor"},
{label: "Contratado(a)", value: "Contratado"},
{label: "Residente", value: "Residente"},
{label: "Aluno(a) de graduação", value: "Aluno de graduação"},
{label: "Aluno(a) de pós-graduação", value: "Aluno de pós-graduação"},
{label: "Pós-doutor(a)", value: "Pós-doutor"},
{label: "Funcionário(a) de empresa terceirizada", value: "Funcionário de empresa terceirizada"},
{label: "Nenhum", value: "Nenhum"}
            ]}/>

        
     



            <p style={{ fontSize: '14px', textAlign: 'center', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#333' }}> {translate('Crie sua senha de acesso')}</p>



            <Input mandatory={true}
                icon={FiLock}
                name="password"
                type="password"
                placeholder={translate('Cadastre sua senha de acesso')}
            />


            <p style={{ fontSize: '14px', textAlign: 'center', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#333' }}> {translate('Privacidade')}</p>


            <SelectSimple mandatory={true} index={15}

                options={[
{label: "Site HCPA", value: "Site HCPA"},
{label: "Instagram", value: "Instagram"},
{label: "Facebook", value: "Facebook"},
{label: "LinkedIn", value: "LinkedIn"},
{label: "E-mail marketing", value: "E-mail marketing"},
{label: "WhatsApp", value: "WhatsApp"},
{label: "Indicação", value: "Indicação"},
{label: "SMS ", value: "SMS "},
{label: "Google", value: "Google"},
{label: "Outros", value: "Outros"}



                ]}
                name="know_about"

                label="Como ficou sabendo do evento?"
            />


                       <CheckboxInput
                style={{ display: 'flex' }}
                name="inscricao_1"
                unique={true}
                preText={(
                    <>
                        {' '}
                      

                        {' '}

                    </>
                )}
                options={[
                    {
                        id: `Aceito receber divulgações dos eventos do HCPA`,
                        label: 'Aceito receber divulgações dos eventos do HCPA',
                        value: `Aceito receber divulgações dos eventos do HCPA`,
                    },

                ]}
            />

            <CheckboxInput
                style={{ display: 'flex' }}
                name="term"
                unique={true}
               
                options={[
                    {
                        id: `Aceito os termos desta plataforma`,
                        label: 'Estou ciente de que estou fornecendo a 45ª Semana Científica do HCPA e seus parceiros meus contatos gerais, os quais são dados pessoais protegidos pela Lei Geral de Proteção de Dados brasileira, para gestão de relacionamento e marketing do 45ª Semana Científica do HCPA, conforme Política de Privacidade disponível neste site. Ao me cadastrar, afirmo que li a Política de Privacidade desta plataforma.',
                        value: `Aceito os termos desta plataforma`,
                    },

                ]}
            />



        </> : <></>}




        {checkUser === 'yes' ? <div className='row'><FaCheck style={{ color: 'green', fontSize: '18px' }} /> <p>Usuário identificado</p></div> : <></>}


    </>
}

export default DefaultSignUpFormV4;